import { Chip, createStyles, makeStyles, Tooltip } from "@material-ui/core";
import React from "react";
import { ActionMeta, ValueType } from "react-select/src/types";
import { ExamTemplateWithStructureIndex } from "../../model/Exam";
import { GetTranslatedValue } from "../../model/Shared/TranslatedValue";
import CustomSelect, { OptionType } from "../common/customSelect/CustomSelect";
import TranslatedMessage from "../translations/TranslatedMessage";

interface ExamSelectProps {
  selectedExamIds: string[];
  exams: ExamTemplateWithStructureIndex[];
  isMulti: boolean;
  readonly?: boolean;
  add?: (examId: string) => void;
  remove?: (examId: string) => void;
  clear?: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    examChip: {
      maxWidth: "100%",
    },
  })
);

const ExamSelect: React.FunctionComponent<ExamSelectProps> = ({
  selectedExamIds,
  exams,
  isMulti,
  readonly,
  add: addTimeSlotExam,
  remove: removeTimeSlotExam,
  clear: clearTimeSlotExams,
}) => {
  const cssClasses = useStyles();

  if (readonly === true) {
    const selectedExams = exams.filter((exam) => selectedExamIds.includes(exam.id));
    const examComponents = selectedExams.map((exam) => {
      const label = GetTranslatedValue(exam.name);
      return (
        <Tooltip title={label} key={exam.id}>
          <Chip className={cssClasses.examChip} label={label} />
        </Tooltip>
      );
    });
    return <>{examComponents}</>;
  }

  const options = exams.map((exam) => {
    const label = GetTranslatedValue(exam.name);
    return { label, value: exam.id };
  });
  const value = options.filter((option) => selectedExamIds.includes(option.value));

  const handleChange = (valueType: ValueType<OptionType>, action: ActionMeta<OptionType> | undefined) => {
    if (!action) {
      return;
    }

    if (action.action === "clear") {
      if (clearTimeSlotExams !== undefined) {
        clearTimeSlotExams();
      }

      return;
    }

    if (action.removedValue && action.action === "remove-value") {
      if (removeTimeSlotExam !== undefined) {
        removeTimeSlotExam(action.removedValue.value);
      }

      return;
    }

    if (action.action === "select-option" && addTimeSlotExam !== undefined) {
      if (isMulti) {
        if (action.option !== undefined) {
          addTimeSlotExam(action.option?.value);
        }
      } else {
        if (valueType !== undefined && valueType !== null) {
          const optionType = valueType as OptionType;
          addTimeSlotExam(optionType.value);
        }
      }
    }
  };

  return (
    <CustomSelect
      xs={12}
      required={false}
      value={value}
      name=""
      label={<TranslatedMessage id="scheduler.message.exam" />}
      placeholder={""}
      options={options}
      isMulti={isMulti}
      isClearable={true}
      onChange={handleChange}
    />
  );
};

export default ExamSelect;
